export const GET_COORDINATES_FROM_BROWSER = "GET_COORDINATES_FROM_BROWSER";
export const FETCH_NAME_FROM_COORDINATES = "FETCH_NAME_FROM_COORDINATES";
export const FETCH_WEATHER = "FETCH_WEATHER";
export const SEARCH_BY_PLACE = 'SEARCH_BY_PLACE';